import { Button, ButtonProps } from '@chakra-ui/react'
import { FC } from 'react'

export const NegativeButton: FC<ButtonProps> = ({ children, ...props }) => {
  return (
    <Button
      borderWidth={1}
      variant="solid"
      borderColor="#030F1C"
      backgroundColor="gray.100"
      _hover={{
        backgroundColor: 'gray.200',
      }}
      _active={{
        backgroundColor: 'gray.300',
      }}
      color="black"
      {...props}
    >
      {children}
    </Button>
  )
}
